/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NetworkIdentifier,
    NetworkIdentifierFromJSON,
    NetworkIdentifierFromJSONTyped,
    NetworkIdentifierToJSON,
    RosettaConstructionMetadataResponseMetadata,
    RosettaConstructionMetadataResponseMetadataFromJSON,
    RosettaConstructionMetadataResponseMetadataFromJSONTyped,
    RosettaConstructionMetadataResponseMetadataToJSON,
    RosettaOperation,
    RosettaOperationFromJSON,
    RosettaOperationFromJSONTyped,
    RosettaOperationToJSON,
    RosettaPublicKey,
    RosettaPublicKeyFromJSON,
    RosettaPublicKeyFromJSONTyped,
    RosettaPublicKeyToJSON,
} from './';

/**
 * ConstructionPayloadsRequest is the request to /construction/payloads. It contains the network, a slice of operations, and arbitrary metadata that was returned by the call to /construction/metadata. Optionally, the request can also include an array of PublicKeys associated with the AccountIdentifiers returned in ConstructionPreprocessResponse.
 * @export
 * @interface RosettaConstructionPayloadsRequest
 */
export interface RosettaConstructionPayloadsRequest {
    /**
     * 
     * @type {NetworkIdentifier}
     * @memberof RosettaConstructionPayloadsRequest
     */
    network_identifier: NetworkIdentifier;
    /**
     * 
     * @type {Array<RosettaOperation>}
     * @memberof RosettaConstructionPayloadsRequest
     */
    operations: Array<RosettaOperation>;
    /**
     * 
     * @type {Array<RosettaPublicKey>}
     * @memberof RosettaConstructionPayloadsRequest
     */
    public_keys?: Array<RosettaPublicKey>;
    /**
     * 
     * @type {RosettaConstructionMetadataResponseMetadata}
     * @memberof RosettaConstructionPayloadsRequest
     */
    metadata?: RosettaConstructionMetadataResponseMetadata;
}

export function RosettaConstructionPayloadsRequestFromJSON(json: any): RosettaConstructionPayloadsRequest {
    return RosettaConstructionPayloadsRequestFromJSONTyped(json, false);
}

export function RosettaConstructionPayloadsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaConstructionPayloadsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'network_identifier': NetworkIdentifierFromJSON(json['network_identifier']),
        'operations': ((json['operations'] as Array<any>).map(RosettaOperationFromJSON)),
        'public_keys': !exists(json, 'public_keys') ? undefined : ((json['public_keys'] as Array<any>).map(RosettaPublicKeyFromJSON)),
        'metadata': !exists(json, 'metadata') ? undefined : RosettaConstructionMetadataResponseMetadataFromJSON(json['metadata']),
    };
}

export function RosettaConstructionPayloadsRequestToJSON(value?: RosettaConstructionPayloadsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'network_identifier': NetworkIdentifierToJSON(value.network_identifier),
        'operations': ((value.operations as Array<any>).map(RosettaOperationToJSON)),
        'public_keys': value.public_keys === undefined ? undefined : ((value.public_keys as Array<any>).map(RosettaPublicKeyToJSON)),
        'metadata': RosettaConstructionMetadataResponseMetadataToJSON(value.metadata),
    };
}

